import { Link } from 'react-router-dom';
import { House, Warning } from '@phosphor-icons/react';
import usePageSeo from '../hooks/usePageSeo';
import './NotFoundPage.css';

function NotFoundPage() {
  usePageSeo({
    title: "404 – העמוד לא נמצא",
    description: "העמוד שחיפשת לא נמצא באתר CliniKit. חזרו לדף הבית או נסו שוב.",
    path: "/404",
    noindex: true,
  });

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon">
          <Warning size={80} weight="duotone" />
        </div>
        <h1>404</h1>
        <h2>העמוד לא נמצא</h2>
        <p>מצטערים, העמוד שחיפשת לא קיים או שאין לך הרשאה לגשת אליו.</p>
        <Link to="/" className="back-home-btn">
          <House size={20} weight="bold" />
          <span>חזרה לדף הבית</span>
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;

